// extracted by mini-css-extract-plugin
export default {"Content":"IntroPage_Content__p-mMX","ContentInner":"IntroPage_ContentInner__bvul0","wrapperCarousel":"IntroPage_wrapperCarousel__S28N0"};